"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { Label } from "@/components/rac/field";
import { Input } from "@/components/rac/input";
import { cn } from "@/utils/cn";
import { useCallback, useState } from "react";
export function OTPModal(t0) {
  const $ = _c(42);
  const {
    isOpen,
    onClose,
    onVerify,
    phoneNumber,
    isVerifying
  } = t0;
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== onVerify || $[1] !== otp) {
    t1 = e => {
      e.preventDefault();
      if (otp.length !== 5) {
        setError("Please enter a valid 5-digit OTP");
        return;
      }
      setError("");
      onVerify(otp);
    };
    $[0] = onVerify;
    $[1] = otp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSubmit = t1;
  let t2;
  if ($[3] !== error) {
    t2 = value => {
      const cleanValue = value.replace(/\D/g, "").slice(0, 6);
      setOtp(cleanValue);
      if (error) {
        setError("");
      }
    };
    $[3] = error;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleOtpChange = t2;
  if (!isOpen) {
    return null;
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="text-heading-5 font-semibold text-neutral-900">Verify Phone Number</h3>;
    t4 = <p className="text-body text-neutral-600">We've sent a 5-digit verification code to</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== phoneNumber) {
    t5 = <div className="text-center space-y-2">{t3}{t4}<p className="text-body font-medium text-neutral-900">{phoneNumber}</p></div>;
    $[7] = phoneNumber;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Label className="text-body-small font-medium text-neutral-800">Enter OTP</Label>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleOtpChange) {
    t7 = e_0 => handleOtpChange(e_0.target.value);
    $[10] = handleOtpChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = error && "border-error-600 focus:border-error-600";
  let t9;
  if ($[12] !== t8) {
    t9 = cn("h-12 rounded-xl border-neutral-200 focus:border-primary-600 text-center text-title font-medium tracking-wider", t8);
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== otp || $[15] !== t7 || $[16] !== t9) {
    t10 = <Input type="text" value={otp} onChange={t7} className={t9} placeholder="Enter 5-digit OTP" maxLength={5} required={true} />;
    $[14] = otp;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== error) {
    t11 = error && <p className="text-caption text-error-600 mt-1">{error}</p>;
    $[18] = error;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <div className="space-y-2">{t6}{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isVerifying || $[24] !== onClose) {
    t13 = <Button type="button" onPress={onClose} className="flex-1 h-12 font-semibold" isDisabled={isVerifying}>Cancel</Button>;
    $[23] = isVerifying;
    $[24] = onClose;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = isVerifying || otp.length !== 5;
  const t15 = isVerifying ? "Verifying..." : "Verify";
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <Button type="submit" className="flex-1 h-12 font-semibold" isDisabled={t14}>{t15}</Button>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t16) {
    t17 = <div className="flex gap-3 pt-2">{t13}{t16}</div>;
    $[29] = t13;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== handleSubmit || $[33] !== t12 || $[34] !== t17) {
    t18 = <form onSubmit={handleSubmit} className="space-y-4">{t12}{t17}</form>;
    $[32] = handleSubmit;
    $[33] = t12;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== isVerifying) {
    t19 = <div className="text-center"><p className="text-caption text-neutral-600">Didn't receive the code?{" "}<button type="button" className="text-primary-600 hover:text-primary-700 font-medium" disabled={isVerifying}>Resend OTP</button></p></div>;
    $[36] = isVerifying;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18 || $[39] !== t19 || $[40] !== t5) {
    t20 = <div className="fixed inset-0 bg-neutral-900/50 flex items-center justify-center p-4 z-50"><div className="bg-white rounded-2xl p-6 w-full max-w-md space-y-6">{t5}{t18}{t19}</div></div>;
    $[38] = t18;
    $[39] = t19;
    $[40] = t5;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
}